module.exports = fox._r("images/lang/de.png", __webpack_public_path__ + "_/_/_/common/frame/images/lang/de.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/lang/de.png
// module id = 113
// module chunks = 2